import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import ByzMuiTypography from 'src/components/core-components/mui/inputs/ByzMuiTypography';
import { useTranslate } from 'src/locales/use-locales';

interface SectionHeaderProps {
  labelKey: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ labelKey }) => {
  const { t } = useTranslate();

  return (
    <Grid
      md={6}
      sx={{
        backgroundColor: '#F4F7FE',
        borderBottom: '1px solid #E0E0E0',
      }}
    >
      <ByzMuiTypography
        sx={{ textAlign: 'center' }}
        fontWeight={500}
        fontSize="14px"
      >
        {t(labelKey)}
      </ByzMuiTypography>
    </Grid>
  );
};

